export const PROFILE_PICTURE_EXPORT_SIZE = 512;
export const PROFILE_PICTURE_FLAT_BACKGROUND = '#f0f0f0';

/**
 * Export a square JPEG crop of the given image.
 * Transparency is flattened onto PROFILE_PICTURE_FLAT_BACKGROUND.
 * The circular mask is a display treatment only — the bitmap is square.
 *
 * @param {HTMLImageElement} image
 * @param {{ scale: number, offsetX: number, offsetY: number, cropDiameter: number }} crop
 * @returns {Promise<Blob>}
 */
export function exportCroppedJpeg(image, crop, options = {}) {
  const {
    size = PROFILE_PICTURE_EXPORT_SIZE,
    background = PROFILE_PICTURE_FLAT_BACKGROUND,
    quality = 0.92,
  } = options;

  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');

  ctx.fillStyle = background;
  ctx.fillRect(0, 0, size, size);

  const { scale, offsetX, offsetY, cropDiameter } = crop;
  const exportScale = size / cropDiameter;
  const drawWidth = image.naturalWidth * scale * exportScale;
  const drawHeight = image.naturalHeight * scale * exportScale;
  const drawX = size / 2 + offsetX * exportScale - drawWidth / 2;
  const drawY = size / 2 + offsetY * exportScale - drawHeight / 2;

  ctx.drawImage(image, drawX, drawY, drawWidth, drawHeight);

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      blob => {
        if (!blob) {
          reject(new Error('export-failed'));
          return;
        }
        resolve(blob);
      },
      'image/jpeg',
      quality,
    );
  });
}
